import ProductCardProfile from "../../../../components/ProductCardProfile";

const ActivatedServices = ({ purchasesServices, onRefresh }) => {
    return (
        !!purchasesServices.length &&
        <div className="basket-wrapper">
            <h4 className="title-in-child">Активовані послуги</h4>
            <div className="basket-wrapper">
                {purchasesServices.map((product, idx) => (
                    <ProductCardProfile key={idx} data={product} onRemove={onRefresh} />
                ))}
            </div>
        </div>
    );
};

export default ActivatedServices;